import React from 'react';
import { Grid, Divider as MuiDivider } from '@mui/material';

const CustomDivider = ({ children, hideRightDivider, hideLefttDivider, ...props }) => (
    <Grid container alignItems="center" spacing={8} {...props}>
        {!hideLefttDivider && <Grid item xs>
            <MuiDivider sx={{borderColor: '#E4E7EC'}}/>
        </Grid>}
        <Grid item>{children}</Grid>
        {!hideRightDivider &&<Grid item xs>
            <MuiDivider sx={{borderColor: '#E4E7EC'}}/>
        </Grid>}
    </Grid>
);

CustomDivider.defaultProps = {
    hideRightDivider: false,
    hideLefttDivider: false,
};

export default CustomDivider;
